<template>
  <b-card
    title="Objectifs de la journée"
    class="shadow-sm"
  >
    <b-row>
      <b-col>
        <b-form-group
          label-for="dailyGoalInformation-input"
          class="mb-0 mt-4 mt-lg-0 w-100 h-100"
          :state="formDailyGoal.dailyGoalInformation.state"
          :invalid-feedback="formDailyGoal.dailyGoalInformation.invalidFeedback"
        >
          <b-form-textarea
            id="dailyGoalInformation-input"
            class="mt-1 h-100"
            :value="formDailyGoal.dailyGoalInformation.value"
            @input="$emit('didChangeDailyGoalInformation', $event)"
            placeholder="Informations sur les objectifs de la journée..."
          ></b-form-textarea>
        </b-form-group>
      </b-col>

    </b-row>
  </b-card>

</template>

<script>
export default {

  name: "DailyStatusCardDailyGoal",

  props: {
    formDailyGoal: {
      type: Object,
      required: true
    },
  },

  methods: {

  }

}
</script>

<style scoped>
.form-group textarea {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/dailyStatus/cards/DailyStatusCardDailyGoal.vue